import { useEffect, useContext } from "react";
import { AuthContext, AppContext } from "@CONTEXTS";
import { useOptions } from "@COMMON";
import { useMe } from "@AUTH";

const useAuth = () => {
  const {
    authenticated,
    dispatch: userDispatch,
    token,
  } = useContext(AuthContext);
  const { dispatch: appDispatch } = useContext(AppContext);

  const { data, loading: meLoading } = useMe(token);

  useEffect(() => {
    if (data?.meData) {
      userDispatch({ type: "SET_USER", payload: data?.meData });
    }
    if (data?.optionsData) {
      appDispatch({ type: "SET_OPTIONS", payload: data?.optionsData });
    }
  }, [userDispatch, data]);

  return {
    authLoading: meLoading,
    authenticated: token ? authenticated : false,
  };
};

export default useAuth;
